import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import EditIcon from "@mui/icons-material/Edit";
import {
  debounce,
  FormControlLabel,
  Switch,
  useMediaQuery,
} from "@mui/material";
import { Autocomplete, TextField } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { Select, MenuItem } from "@mui/material";
import { axiosInstance } from "./../../utility/apiInstance";
import { useNavigate } from "react-router-dom";
import { useRole } from "../../components/MangeContextProvide";
import InputMask from "react-input-mask";
import { User, UserCheck, UserX } from "lucide-react";
import {
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
  GridSlots,
  GridToolbarProps,
} from "@mui/x-data-grid";
// import { randomId } from "@mui/x-data-grid-generator";

import toast from "react-hot-toast";
import {
  hideToggleButton,
  hideToggleButtonEditMode,
  preventAddingDuplocateRow,
} from "../../utility/constant";
import clsx from "clsx";
import SearchInput from "../../common/SearchInput";
import { CustomLoadingOverlay, CustomNoRowsOverlay } from "../../common/Datagridoverlays";
import { FOOTER_HEIGHT, HEADER_HEIGHT, MIN_GRID_HEIGHT, ROW_ESTIMATE } from "../Contants/constantValue";

const MAX_GRID_HEIGHT = 500;
function randomId() {
  return Math.random().toString(36).substr(2, 9);
}

const id = randomId();
function EditToolbar(props: EditToolbarProps) {
  const {
    setRows,
    setRowModesModel,
    currentPage,
    isAddDisabled,
    setIsAddDisabled,
  } = props;

  const handleClick = () => {
    const id = Math.random();
    setRows((oldRows) => {
      if (!preventAddingDuplocateRow(oldRows)) {
        const isAnyRowInEditMode = oldRows.some(
          (row: any) => row.isNew || row.isEditing
        );
        if (isAnyRowInEditMode) {
          toast.error("You can only submit one record at a time!");
          return oldRows;
        }
      }
      setIsAddDisabled(true);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "name" },
      }));
      return [
        {
          id,
          name: "",
          number: "",
          email: "",
          organisation: "",
          module: "",
          role: "",
          isActive: true,
          isNew: true,
          ishideToggle: false,
          globalData: 1,
          globalDirectory: "",
        },
        ...oldRows,
      ];
    });
  };
  return currentPage === 0 ? (
    <div className="buttonadd">
      <Button
        className={clsx("btnTheme btnPadding", {
          "opacity-50 cursor-not-allowed": isAddDisabled,
        })}
        color="primary"
        sx={{
          backgroundColor: "#F9BF38",
          color: "black",

          "&:hover": {
            backgroundColor: "#F9BF38",
          },
        }}
        onClick={handleClick}
        disabled={isAddDisabled}
      >
        Add record
      </Button>
    </div>
  ) : null;
}
interface EditToolbarProps extends GridToolbarProps {
  setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
  setRowModesModel: (
    newModel: (oldModel: GridRowModesModel) => GridRowModesModel
  ) => void;
  currentPage: number;
  isAddDisabled: boolean;
  setIsAddDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}


const PAGE_SIZE = 10;

export default function FullFeaturedCrudGrid() {

  const is1366 = useMediaQuery("(max-width:1366px)");
  const navigate = useNavigate();
  const [rows, setRows] = React.useState<any>([]);
  const { role, organizationId } = useRole() as any;
  const [organization, setOrganization] = React.useState<any>();
  const [rowdata, setRowdata] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [totalCustomersAdmin, setTotalCustomersAdmin] = React.useState(0);
  const [activeCustomersAdmin, setActiveCustomersAdmin] = React.useState(0);
  const [inActiveCustomersAdmin, setInActiveCustomersAdmin] = React.useState(0);
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>(
    {}
  );
  const [isAddDisabled, setIsAddDisabled] = React.useState(false);
  const [modules, setModules] = React.useState<string[]>([]);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [debouncedSearch, setDebouncedSearch] = React.useState("");
  const handleLogout = (): void => {
    localStorage.clear();
    navigate("/");
  };

  const getCustomerList = async (search: string = "") => {
    setLoading(true);
    try {
      let response = await axiosInstance.get(`api/v1/customers-auth/all-customers?search=${search}`);
      const fetchedRows = response?.data?.data;
      const data = fetchedRows.map((row: any, index: any) => ({
        ...row,
        key: row?._id || row?.id,
        id: row?._id || row?.id,
        name: row?.name,
        ishideToggle: true,
        number: row?.contactInfo?.phone,
        email: row?.contactInfo?.email,
        organisation: row?.organisationId,
        module: row?.module,
        s_no: index + 1,
        isNew: false,
        role: row?.role,
        globalData: row?.globalData,
        globalDirectory: row?.globalDirectory,
      }));
      setRows(data);
      if (response.data.statusCode === 401) {
        handleLogout();
      }
    } catch (err: any) {
      setRows([])
    } finally {
      setLoading(false);
    }
  };
  // debounce search effect
  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);


  React.useEffect(() => {
    getCustomerList(debouncedSearch);
  }, [debouncedSearch]);

  const handleRowEditStop: GridEventListener<"rowEditStop"> = (
    params,
    event
  ) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    setIsAddDisabled(true);
  };
  const handleSaveClick = (id: GridRowId) => async () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    setRows((prev: any) => {
      let array = [...prev];
      let findIndex = array.findIndex((item: any) => item?._id === id);
      if (findIndex !== -1) {
        array[findIndex].ishideToggle = false;
        array[findIndex].isEditing = false;
      }
      return array;
    });
    setIsAddDisabled(false);
  };

  const debouncedHandleDeleteClick = debounce(
    async (id: GridRowId, row: any) => {
      const url = `/api/v1/customers-auth/customer/delete/${id}`;

      const updatedIsActive = !row.isActive;

      const payload = { isActive: updatedIsActive };

      try {
        const response = await axiosInstance.delete(url, {
          data: payload,
        });

        if (response.status !== 200) {
          toast.error("Error updating customer status.");
        } else {
          toast.success(response?.data?.message);
          getCustomerList("");
          fetchCustomerCount();
        }
      } catch (error: any) {
        error?.response?.data?.error
          ? toast.error(error.response.data.error)
          : toast.error("An error occurred while updating customer status.");
      }
    },
    300
  );

  const handleDeleteClick = (id: GridRowId, row: any) => async () => {
    debouncedHandleDeleteClick(id, row);
  };

  const handleCancelClick = (id: GridRowId) => async () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow: any = rows.find((row: any) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
    if (!editedRow.isNew) {
      setRows((prev: any) => {
        let array = [...prev];
        let findIndex = array.findIndex((item: any) => item?._id === id);
        if (findIndex !== -1) {
          array[findIndex].ishideToggle = true;
          array[findIndex].isEditing = false;
        }
        return array;
      });
    }
    setIsAddDisabled(false);
  };

  const gmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const processRowUpdate = async (newRow: GridRowModel, params: any) => {
    const updatedRow: any = { ...newRow, isNew: false, isEditing: false };
    setRowdata(updatedRow);
    const errors = [];
    if (!updatedRow.name) {
      errors.push("Name cannot be empty");
      setIsAddDisabled(true);
    } else if (updatedRow.name?.length < 3) {
      errors.push("Name must be more than 3 character long");
      setIsAddDisabled(true);
    }
    if (!updatedRow.number) {
      errors.push("Number cannot be empty");
      setIsAddDisabled(true);
    } else if (updatedRow?.number?.length !== 10) {
      errors.push(" Phone number must be of 10 digits");
      setIsAddDisabled(true);
    }
    if (!updatedRow.email) {
      errors.push("Email cannot be empty");
      setIsAddDisabled(true);
    } else if (!gmailRegex.test(updatedRow.email)) {
      errors.push("Invalid email address");
      setIsAddDisabled(true);
    }
    if (!updatedRow.organisation) {
      errors.push("Organisation cannot be empty");
      setIsAddDisabled(true);
    }
    if (!updatedRow.role) {
      errors.push("Role cannot be empty");
      setIsAddDisabled(true);
    }
    if (
      role === "customeradmin" &&
      (!updatedRow?.module || updatedRow?.module.length === 0)
    ) {
      errors.push("Module cannot be empty");
      setIsAddDisabled(true);
    }

    if (errors.length > 0) {
      if (
        updatedRow.id ===
        rows?.find((item: any) => item._id === updatedRow._id)?._id
      ) {
        setRows(hideToggleButton(rows, updatedRow.id));
      }
      errors.forEach((error) => toast.error(error));
      return;
    }

    if (+updatedRow.id < 1) {
      updatedRow.id = id;
      const formData = {
        name: updatedRow.name,
        username: updatedRow.email,
        role: updatedRow.role,
        module: Array.isArray(updatedRow.module)
          ? updatedRow.module
          : [updatedRow.module],
        organisationId: updatedRow.organisation?._id,
        globalData: updatedRow.globalData || 0,
        globalDirectory: true,
        contactInfo: {
          email: updatedRow.email,
          phone: updatedRow.number,
        },
      };
      try {
        const response = await axiosInstance.post(
          "api/v1/customers-auth/register",
          formData
        );
        const data = response.data;
        toast.success("Customer registered successfully");
        getCustomerList("");
      } catch (err: any) {
        if (
          updatedRow.id ===
          rows?.find((item: any) => item._id === updatedRow._id)?._id
        ) {
          setRows(hideToggleButtonEditMode(rows, updatedRow));
        }
        Array?.isArray(err?.response?.data?.error)
          ? err?.response?.data?.error?.forEach((error: any) => {
            toast.error(`${error.message}`);
          })
          : toast?.error(err.response.data.error) ||
          toast?.error("An error occurred during registration.");
      }
    } else {
      const sendData = {
        name: updatedRow.name,
        username: updatedRow.email,
        role: updatedRow.role,
        module: Array.isArray(updatedRow.module)
          ? updatedRow.module
          : [updatedRow.module],
        organisationId: updatedRow.organisation?._id,
        contactInfo: {
          email: updatedRow.email,
          phone: updatedRow.number,
        },
        globalData: updatedRow.globalData || 0,
        globalDirectory: true,
      };

      const url = `api/v1/customers-auth/customer/update/${updatedRow._id}`;

      try {
        const response = await axiosInstance.patch(url, sendData);
        const data = response.data;
        setRows((prev: any) => {
          let array = [...prev];
          let findIndex = array.findIndex(
            (item: any) => item?._id === response?.data?.data?._id
          );
          if (findIndex !== -1) {
            array[findIndex].ishideToggle = true;
          }
          return array;
        });
        toast.success(data?.message);
        getCustomerList("");

        return updatedRow;
      } catch (err: any) {
        if (
          updatedRow.id ===
          rows?.find((item: any) => item._id === updatedRow._id)?._id
        ) {
          setRows(
            (prevRows: any) => hideToggleButtonEditMode(prevRows, updatedRow) // Revert state on error
          );
        }
        if (Array.isArray(err.response?.data?.error)) {
          err.response.data.error.forEach((error: any) => {
            toast.error(`${error.message}`);
          });
        } else {
          err.response?.data?.error
            ? toast.error(err.response?.data?.error)
            : toast.error("An error occurred during customer update.");
        }

        setRows((prevRows: any) =>
          hideToggleButtonEditMode(prevRows, updatedRow)
        );
      }
    }
  };
  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };
  const handlePaginationChange = (paginationModel: any) => {
    setCurrentPage(paginationModel.page);
  };

  const organizationdata = async () => {
    try {
      const response = await axiosInstance.get("/api/v1/organisation");
      const fetchedorganization = response?.data?.data;
      const filtereddata = fetchedorganization.filter(
        (item: any, index: number, arr: any) =>
          arr.findIndex(
            (obj: any) => obj.organizationName === item.organizationName
          ) === index
      );
      setOrganization(filtereddata);
      if (response.data.statusCode === 401) {
        handleLogout();
      }
    } catch (err: any) { }
  };
  React.useEffect(() => {
    organizationdata();
  }, []);


  const handleGlobalDataToggle = async (id: any, checked: boolean) => {
    const value = checked ? 1 : 0
    setRows((prevRows: any) =>
      prevRows.map((row: any) =>
        row.id === id
          ? { ...row, globalData: value }
          : row
      )
    );
    try {
      const url = `/api/v1/customers-auth/customer/update/status/${id}`
      const response = await axiosInstance.patch(url, { status: value });
      const data = response.data;
      if (response?.data?.success) {
        toast.success("Status Updated")
      }
    } catch (error: any) {
      console.error("Error on Change globalData", error)

      setRows((prevRows: any) =>
        prevRows.map((row: any) =>
          row.id === id
            ? { ...row, globalData: !value }
            : row
        )
      );

      toast.error("Unable Update Status")
    }
  };

  const fetchCustomerCount = async () => {
    try {
      let response = await axiosInstance.get(
        `/api/v1/organisation/customer-count`
      );
      if (response?.data?.success) {
        const { totalCustomers, activeCustomers, inActiveCustomers } =
          response.data.data;

        setTotalCustomersAdmin(totalCustomers);
        setActiveCustomersAdmin(activeCustomers);
        setInActiveCustomersAdmin(inActiveCustomers);
      }
    } catch (error: any) { }
  };

  React.useEffect(() => {
    role == "admin" && fetchCustomerCount();
  }, []);

  const handleModule = async () => {
    try {
      let response = await axiosInstance.get(`/api/v1/organisation/module`);
      setModules(response?.data?.data || []);


    } catch (error) {

    }
  };

  React.useEffect(() => {
    handleModule();
  }, []);


  const moduleOptions = {
    "1": "Air",
    "2": "Ocean",
  };
  // const menuOptions = {
  //   1: "Full Organizational data",
  //   // 2: "Team's data",
  //   3: "Self data only",
  // } as any;

  const menuOptionsformdata = {
    "Full Organizational data": "1",
    // "Team's data": "2",
    "Self data only": "3",
  } as any;

  const gridHeight = Math.min(
    MAX_GRID_HEIGHT,
    Math.max(
      MIN_GRID_HEIGHT,
      HEADER_HEIGHT + FOOTER_HEIGHT + Math.min(Math.max(rows.length, 1), PAGE_SIZE) * ROW_ESTIMATE
    )
  );

  const columns: GridColDef[] = [
    {
      field: "s_no",
      headerName: "S.No.",
      // width: 70,
      width: is1366 ? 50 : 70,
      sortable: true,
      filterable: false,
      editable: false,
      disableColumnMenu: true,
    },
    {
      field: "name",
      headerName: "Name",
      // width: 200,
      width: is1366 ? 170 : 200,
      sortable: true,
      filterable: true,
      // editable: true,
    },
    {
      field: "number",
      headerName: "Mobile No.",
      // width: 130,
      width: is1366 ? 100 : 130,
      sortable: true,
      filterable: true,
      // editable: true,
      renderEditCell: (params) => {
        const handlePhoneNumberChange = (
          event: React.ChangeEvent<HTMLInputElement>
        ) => {
          params.api.setEditCellValue({
            id: params.id,
            field: params.field,
            value: event.target.value,
          });
        };

        return (
          <InputMask
            mask="9999999999"
            maskChar={null}
            value={params.value || ""}
            onChange={handlePhoneNumberChange}
          >
            {(inputProps: any) => (
              <TextField
                {...inputProps}
                fullWidth
                inputProps={{
                  maxLength: 13,
                }}
              />
            )}
          </InputMask>
        );
      },
    },

    {
      field: "email",
      headerName: "Email ID",
      width: is1366 ? 200 : 300,
      sortable: true,
      filterable: true,
      // editable: true,
    },

    ...(role === "customeradmin"
      ? [
        {
          field: "module",
          headerName: "Module",
          //width: 170,
          width: is1366 ? 100 : 170,
          sortable: true,
          filterable: true,
          // editable: true,
          renderCell: (params: { value?: ("1" | "2")[] }) => {
            if (!params.value) return "";
            return Array.isArray(params.value)
              ? params.value.map((val) => moduleOptions[val]).join(", ")
              : "";
          },
          renderEditCell: (params: any) => {
            const availableModules = modules;

            const handleChange = (event: any) => {
              const {
                target: { value },
              } = event;
              params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value: typeof value === "string" ? [value] : value,
              });
            };

            const handleDelete = (valueToDelete: string) => {
              const currentValue = Array.isArray(params.value)
                ? params.value
                : [];
              const newValue = currentValue.filter(
                (val: any) => val !== valueToDelete
              );
              params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value: newValue,
              });
            };
            return (
              <Select
                multiple
                value={Array.isArray(params.value) ? params.value : []}
                onChange={handleChange}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((val: any) => (
                      <Chip
                        key={val}
                        label={moduleOptions[val as "1" | "2"]}
                        onDelete={() => handleDelete(val)}
                        onMouseDown={(e) => e.stopPropagation()}
                      />
                    ))}
                  </Box>
                )}
                sx={{
                  width: "100%",
                  backgroundColor: "#f0f0f0",
                  height: "35px",
                  marginTop: "7px",
                  borderRadius: "4px",
                  padding: "0px",
                }}
                className="selctmodulee"
              >
                {availableModules.includes("1") && (
                  <MenuItem value="1">Air</MenuItem>
                )}
                {availableModules.includes("2") && (
                  <MenuItem value="2">Ocean</MenuItem>
                )}
              </Select>
            );
          },
        },
      ]
      : []),

    {
      field: "organisation",
      headerName: "Organisation",
      // width: 270,
      width: is1366 ? 150 : 270,
      sortable: true,
      filterable: true,
      // editable: true,
      renderCell: (params) => (
        <>{params?.row?.organisation?.organizationName}</>
      ),
      renderEditCell: (params) => {
        if (role === "admin" && params.row?.id === params?.row?._id)
          return <>{params?.row?.organisation?.organizationName}</>;
        return (
          <Autocomplete
            value={organization?.find(
              (org: any) => org._id === params.value?._id
            )}
            options={organization?.filter((org: any) => org.isActive) || []}
            getOptionLabel={(option) => option.organizationName}
            sx={{ width: "150%" }}
            onChange={(event, newValue) => {
              params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value: newValue ? newValue : "",
              });
            }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" fullWidth />
            )}
          />
        );
      },
    },

    {
      field: "role",
      headerName: "Customer Role",
      // width: 160,
      width: is1366 ? 120 : 160,
      editable: true,
      type: "singleSelect",

      valueOptions: role === "admin"
        ? [
          { value: "customeradmin", label: "customeradmin" },
          { value: "groundstaff", label: "groundstaff" },
        ]
        : [
          { value: "customeruser", label: "CustomerUser" },
          { value: "groundstaff", label: "GroundStaff" },
        ],
    },


    {
      field: "globalData",
      headerName: "Global Data",
      //width: 200,
      width: is1366 ? 100 : 200,
      sortable: true,
      filterable: true,

      renderCell: (params) => {
        const { id, value } = params;
        return (
          <Switch
            className="thinSwitch"
            checked={Boolean(value)}
            disabled={params.row.role == "groundstaff"}
            onChange={(e) => handleGlobalDataToggle(id, e.target.checked)}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "green",
                "& + .MuiSwitch-track": {
                  backgroundColor: "green",
                },
              },
              "& .MuiSwitch-switchBase": {
                color: "red",
                "& + .MuiSwitch-track": {
                  backgroundColor: "white",
                },
              },
            }}
          />
        );
      },
    },
    {
      field: "isActive",
      headerName: "Status",
      width: is1366 ? 90 : 120,
      flex: 0,
      // ...(isBigScreen
      //   ? { flex: 1, width: 150 }
      //   : { flex: 0 }),
      sortable: true,
      filterable: false,
      renderCell: (params) => (params.row.isActive ? "Active" : "Inactive"),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: is1366 ? 120 : 120,
      cellClassName: "actions",
      getActions: ({ id, row }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              key={`save-${id}`}
              icon={<SaveIcon />}
              className="iconMilestone_save"
              label="Save"
              sx={{
                color: "primary.main",
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              key={`cancel-${id}`}
              label="Cancel"
              className="iconMilestone_close"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }
        if (!row?.ishideToggle) {
          return [<></>];
        }
        return [

          <GridActionsCellItem
            icon={<EditIcon />}
            key={`edit-${id}`}
            label="Edit"
            className="iconMilestone_edit"
            onClick={handleEditClick(id)}
            color="inherit"
            disabled={!row.isActive}
          />,
          <GridActionsCellItem
            key={`delete-${id}`}
            icon={
              <FormControlLabel
                control={
                  <Switch
                    className="thinSwitch ml-2"
                    checked={row.isActive}
                    sx={(theme) => ({
                      "& .MuiSwitch-switchBase": {
                        "&.Mui-checked": {
                          color: "green",
                          "& + .MuiSwitch-track": {
                            backgroundColor: "green",
                          },
                        },
                        "&.Mui-unchecked": {
                          color: "#ff0000",
                          "& + .MuiSwitch-track": {
                            backgroundColor: "red",
                          },
                        },
                      },
                    })}
                  />
                }
                label=""
              />
            }
            label="Delete"
            onClick={handleDeleteClick(id, row)}
            color="inherit"
          />,

        ];
      },
    },
  ];
  const customerAdminColumns = columns.filter(
    (col) => col.field === "globalData" || col.field === "globalDirectory"
  );

  const finalColumns =
    role === "customeradmin"
      ? columns
      : columns.filter((col) => !customerAdminColumns.includes(col));
  return (
    <>
      {role === "admin" && (
        <div className="grid grid-cols-12 mt-5 gap-0 lg:gap-5  md:gap-5  sm:gap-5">
          <div className="col-span-12 lg:col-span-4 sm:col-span-4 md:col-span-4">
            <div className="BoxWhite flex justify-between iconsize">
              <>
                <aside>
                  <span className="text-xl">Users</span>
                  <h6 className="text-lg text-gray-600">
                    {totalCustomersAdmin}
                  </h6>
                </aside>

                <figure className="shape justify-center flex">
                  <User className="w-8 h-8 text-orange-400" />
                </figure>
              </>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-4 sm:col-span-4 md:col-span-4">
            <div className="BoxWhite flex justify-between iconsize">
              <aside>
                <span className="text-xl">Active users</span>
                <h6 className="text-lg text-gray-600">
                  {activeCustomersAdmin}
                </h6>
              </aside>

              <figure className="shape justify-center flex">
                <UserCheck className="w-8 h-8 text-green-500" />
              </figure>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-4 sm:col-span-4 md:col-span-4">
            <div className="BoxWhite flex justify-between iconsize">
              <aside>
                <span className="text-xl">Inactive users</span>
                <h6 className="text-lg text-gray-600">
                  {inActiveCustomersAdmin}
                </h6>
              </aside>

              <figure className="shape justify-center flex">
                <UserX className="w-8 h-8 text-red-500" />
              </figure>
            </div>
          </div>
        </div>
      )}

      <div className="old_dashboard_title flex items-center justify-between mb-[10px]">
        <h1 className="text-2xl font-bold text-gray-700 mt-0">
          Manage Users
        </h1>

        <SearchInput
          placeholder="Search "
          onChange={setSearchQuery}
          width={400}
        />

      </div>

      <div className="whiteBox">
        <Box
          sx={{
            height: gridHeight,
            width: "100%",
            overflowX: "auto",
            "& .actions": {
              color: "text.secondary",
            },
            "& .textPrimary": {
              color: "text.primary",
            },
            "& .new-row-border": {},
            boxShadow: "0 1px 2px rgba(0, 0, 0, .06), 0 2px 8px rgba(0, 0, 0, .05)",
          }}
        >
          <DataGrid
            rows={rows?.map((item: any, index: number) => ({
              ...item,
              s_no: index + 1,
            }))}
            columns={finalColumns}
            loading={loading}
            editMode="row"
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            onPaginationModelChange={handlePaginationChange}
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            pageSizeOptions={[10]}
            getRowId={(row) => row?.id || row?._id}
            // slots={{
            //   toolbar: EditToolbar as GridSlots["toolbar"],
            // }}
            slots={{
              loadingOverlay: CustomLoadingOverlay,
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            slotProps={{
              toolbar: {
                setRows,
                setRowModesModel,
                currentPage,
                isAddDisabled,
                setIsAddDisabled,
              } as GridToolbarProps,
              loadingOverlay: { message: "Loading users..." },
              noRowsOverlay: { message: "No users found" },
            }}
            sx={{
              // Keeps the loading spinner / "No rows" message from collapsing
              // into a tiny sliver when there's no row data to size against.
              "--DataGrid-overlayHeight": "300px",
              "& .MuiDataGrid-root": {
                fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
              },
            }}
            autoHeight={false}
            rowHeight={38}
            columnHeaderHeight={42}
          />
        </Box>
      </div>
    </>
  );
}